<app-scanner></app-scanner>

<div class="home-deliver-details-header">
  <app-info-bar [homeDelivery]="homeDelivery"></app-info-bar>
  <app-message-bar></app-message-bar>
</div>
<div class="home-delivery-details-content">
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="home-delivery-status-line">
        <div class="contract-number">
          <span class="pre-contract-number">#</span>{{ homeDelivery.contractNumber }}
        </div>

        <div class="item-status-and-additional-items">
          <div class="item-status" [class.complete]="homeDelivery.isComplete">
            <span>{{ homeDelivery.status.isEmpty ? '?' : homeDelivery.status.scanned }}
              / {{ homeDelivery.status.isEmpty ? '?' : homeDelivery.status.total}}</span>
              <mat-icon>check_circle_outline</mat-icon>
          </div>
          <div *ngIf="showIncreaseItemOption" class="additional-items">
            <button mat-icon-button color="primary" (click)="increaseItemCount()">
              <mat-icon>add_circle_outline</mat-icon>
            </button>
          </div>
        </div>

      </div>

      <div *ngFor="let category of homeDelivery.status.categories" class="item-category-line"
           [class.complete]="category.isComplete">
        <mat-icon class="category-icon" [svgIcon]="category.iconName"></mat-icon>
        <span>{{ category.name }}</span>

        <span style="flex-grow: 1"></span>
        <span>{{ category.scannedCount }}/{{ category.totalCount }}</span>
        <mat-icon class="checkmark">check_circle_outline</mat-icon>
      </div>

      <div class="home-delivery-details" *ngFor="let participant of [homeDelivery.participant, homeDelivery.secondaryParticipant]">

        <table *ngIf="participant">

          <!-- Time frame -->
          <tr *ngIf="participant?.timeFrame">
            <td>
              <mat-icon inline="true">access_time</mat-icon>
            </td>
            <td>
              <span>{{ participant.timeFrame }}</span>
            </td>
          </tr>

          <!-- Name -->
          <tr>
            <td>
              <mat-icon inline="true">person</mat-icon>
            </td>
            <td>
              <span>{{ participant.name || '-' }}</span>
            </td>
          </tr>

          <!-- Address -->
          <tr>
            <td>
              <mat-icon inline="true">location_on</mat-icon>
            </td>
            <td>
              <span><a (click)="openAddress(participant.address)">{{ participant.address.street || '-' }} {{ participant.address.streetNumber || '' }}</a></span>
              <br>
              <!-- Do not put a linebreak inside the span, as it will show up in the view -->
              <span><a (click)="openAddress(participant.address)">{{ participant.address.zipCode || '-' }} {{ participant.address.city || '-' }}</a></span>
            </td>
          </tr>

          <!-- Mobile -->
          <tr *ngIf="participant?.contactData?.mobile">
            <td>
              <mat-icon inline="true">phone_iphone</mat-icon>
            </td>
            <td>
              <span><a href="tel:{{participant.contactData.mobile}}">{{ participant.contactData.mobile }}</a></span>
            </td>
          </tr>

          <!-- Landline -->
          <tr *ngIf="participant?.contactData?.landline">
            <td>
              <mat-icon inline="true">call</mat-icon>
            </td>
            <td>
              <span><a href="tel:{{participant.contactData.landline}}">{{ participant.contactData.landline }}</a></span>
            </td>
          </tr>

          <!-- Additional notes -->
          <tr *ngIf="participant?.additionalNotes">
            <td>
              <mat-icon inline="true">chat_bubble</mat-icon>
            </td>
            <td>
              <span>{{ participant.additionalNotes }}</span>
            </td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div class="home-delivery-details-footer">
  <button class="footer-button" mat-flat-button color="primary" (click)="done()">{{ 'done' | translate }}</button>
</div>
